import React, { useState } from "react";
import artwork from "./rankArtwork.json";

let nextGradientId = 0;

export default function RankNumber({ rank }) {
  const [gradientId] = useState(() => `atlas-rank-shade-${nextGradientId++}`);
  const number = artwork[rank - 1];
  if (!number) return null;

  return (
    <svg
      className="cinema-card-rank"
      viewBox={number.viewBox}
      preserveAspectRatio="xMaxYMid meet"
      aria-hidden="true"
      focusable="false"
    >
      <defs>
        <linearGradient
          id={gradientId}
          {...number.gradient}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="currentColor" />
          <stop offset="1" stopColor="currentColor" stopOpacity="0" />
        </linearGradient>
      </defs>
      <path
        d={number.path}
        fill={`url(#${gradientId})`}
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </svg>
  );
}
